import { SettingsCheckboxItem } from 'modules/settingsContainer/SettingsCheckbox/types';
import { PieIndicatorLabelFormatType } from 'store/reducers/visualisations/types';

export const pieLabelOptions: SettingsCheckboxItem<PieIndicatorLabelFormatType>[] = [
  { value: 'value', label: 'Значение' },
  { value: 'name', label: 'Название' },
];
